import React, { useState, useEffect } from 'react';

const CustomWizard = ({ 
    steps, 
    startingStep = 0, 
    previousBtnName = "Anterior", 
    nextBtnName = "Siguiente", 
    onSubmit, 
    primaryBtnClass = "", 
    secondaryBtnClass = "" 
}) => {
    const [currentStep, setCurrentStep] = useState(startingStep);
    const [isSubmitting, setIsSubmitting] = useState(false);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [currentStep]);

    const handleNext = async () => {
        if (isSubmitting) return;
        
        setIsSubmitting(true);
        const currentStepObj = steps[currentStep];
        
        let isValid = true;
        if (typeof currentStepObj.validator === 'function') {
            isValid = await currentStepObj.validator();
        }

        if (isValid) {
            if (currentStep === steps.length - 1) {
                if (typeof onSubmit === 'function') {
                    onSubmit();
                }
            } else {
                setCurrentStep(prev => prev + 1);
            }
        }
        setIsSubmitting(false);
    };

    const handlePrev = () => {
        if (currentStep > 0) {
            setCurrentStep(prev => prev - 1);
        }
    };

    return (
        <div style={{ width: '100%', fontFamily: "'Lato', sans-serif" }}>
            
            {/* Stepper Premium Segmentado */}
            <div style={{ 
                display: 'flex', 
                justifyContent: 'space-between', 
                marginBottom: '50px',
                gap: '8px'
            }}>
                {steps.map((step, index) => {
                    const isActive = index === currentStep;
                    const isCompleted = index < currentStep;
                    
                    // Colores profesionales minimalistas
                    const barColor = isCompleted || isActive ? '#cd171a' : '#e5e7eb';
                    const textColor = isActive ? '#111827' : (isCompleted ? '#cd171a' : '#9ca3af');
                    const fontWeight = isActive ? '700' : '600';

                    return (
                        <div key={index} style={{ 
                            flex: 1, 
                            display: 'flex', 
                            flexDirection: 'column'
                        }}>
                            {/* Barra Segmentada */}
                            <div style={{
                                height: '4px',
                                width: '100%',
                                backgroundColor: barColor,
                                borderRadius: '2px',
                                marginBottom: '12px',
                                transition: 'background-color 0.4s ease'
                            }}></div>
                            
                            {/* Texto del Paso */}
                            <div style={{
                                fontSize: '11px',
                                textTransform: 'uppercase',
                                letterSpacing: '1px',
                                color: textColor,
                                fontWeight: fontWeight,
                                transition: 'color 0.4s ease'
                            }}>
                                <span style={{ opacity: isActive ? 1 : 0.7, marginRight: '4px' }}>
                                    {String(index + 1).padStart(2, '0')}
                                </span>
                                {step.label || step.name}
                            </div>
                        </div>
                    );
                })}
            </div>

            {/* Content Area */}
            <div style={{ minHeight: '300px', marginBottom: '40px' }}>
                {steps[currentStep] && steps[currentStep].content}
            </div>

            {/* Footer Buttons Premium */}
            <div style={{ 
                display: 'flex', 
                justifyContent: 'space-between', 
                paddingTop: '25px', 
                borderTop: '1px solid #f3f4f6' 
            }}>
                <div>
                    {currentStep > 0 && (
                        <button 
                            className={secondaryBtnClass || "btn btn-secondary"} 
                            onClick={handlePrev}
                            disabled={isSubmitting}
                            style={{
                                padding: '10px 24px',
                                borderRadius: '6px',
                                fontWeight: '600',
                                fontSize: '14px',
                                letterSpacing: '0.5px',
                                transition: 'all 0.2s ease',
                                border: '1px solid #e5e7eb',
                                backgroundColor: '#ffffff',
                                color: '#4b5563'
                            }}
                        >
                            {previousBtnName}
                        </button>
                    )}
                </div>
                <div>
                    {currentStep < steps.length - 1 && (
                        <button 
                            className={primaryBtnClass || "btn btn-primary"} 
                            onClick={handleNext}
                            disabled={isSubmitting}
                            style={{
                                padding: '10px 24px',
                                borderRadius: '6px',
                                fontWeight: '600',
                                fontSize: '14px',
                                letterSpacing: '0.5px',
                                transition: 'all 0.2s ease',
                                backgroundColor: '#cd171a',
                                border: 'none',
                                color: '#ffffff'
                            }}
                        >
                            {nextBtnName}
                        </button>
                    )}
                </div>
            </div>

        </div>
    );
};

export default CustomWizard;
